export enum MultiSelectSize {
  MID = 'mid',
  LARGE = 'large',
}

export enum MultiSelectBackground {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum MultiSelectItemHighlightColor {
  BLUE_DARK = 'blue-dark',
  GRAY = 'gray',
}

export enum MultiSelectCounterPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export type MultiSelectInputBlurBehaviour = 'none' | 'add' | 'clear';

export const MULTISELECT_THROTTLE_TIME = 50; // ms
